import FacebookIcon from '../../assets/icons/facebook.svg'
import InstagramIcon from '../../assets/icons/instagram.svg'
import TiktokIcon from '../../assets/icons/tiktok.svg'
import WhatsappIcon from '../../assets/icons/whatsapp.svg'
import GlobeIcon from '../../assets/icons/globe.svg'

// Iconos que el footer sabe dibujar. Las claves son los slugs que guarda
// `red_social.icono` y tienen que coincidir con la whitelist de
// contenido/index.php: si el backend recibe uno que no está acá, lo guarda
// como 'globe'.
export const socialIcons = {
  facebook: { label: 'Facebook', icon: FacebookIcon },
  instagram: { label: 'Instagram', icon: InstagramIcon },
  tiktok: { label: 'TikTok', icon: TiktokIcon },
  whatsapp: { label: 'WhatsApp', icon: WhatsappIcon },
  globe: { label: 'Otra (genérico)', icon: GlobeIcon }
}

export const DEFAULT_SOCIAL_ICON = 'globe'

export const getSocialIcon = slug =>
  (socialIcons[slug] || socialIcons[DEFAULT_SOCIAL_ICON]).icon

export const getSocialIconLabel = slug =>
  (socialIcons[slug] || socialIcons[DEFAULT_SOCIAL_ICON]).label
